export {};

import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

NLMK.disableScroll = (Target) => disableBodyScroll(Target);
NLMK.enableScroll = (Target) => enableBodyScroll(Target);



// WEBPACK FOOTER //
// ./js/main/package/toggle-scroll.js